<template>
  <div v-if="tooltip">
    <v-tooltip :disabled="!tooltip" top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="$emit('click', $event)"
          x-large
          :icon="!text"
          color="primary"
        >
          <div style="margin-right: 8px" v-if="text">{{ text }}</div>
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span v-if="tooltip">{{ tooltip }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    <v-btn
      @click="$emit('click', $event)"
      x-large
      :icon="!text"
      color="primary"
    >
      <div style="margin-right: 8px" v-if="text">{{ text }}</div>
      <v-icon>{{ icon }}</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "IconButton",
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },
})
</script>
